module.exports = __webpack_public_path__ + "static/img/technology9.e356839b.png";